export default __webpack_public_path__ + "static/media/LogoWebAdministracionSmaller.8ba7d4be.png";